import { useState, type FunctionComponent } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Row, Segmented, Space } from "antd";
import { useTranslation } from "react-i18next";

import { PaymentGateway } from "@fitness-app/data-models/entities/ProductsSettings";

import { paymentGatewayOptions } from "~/modules/Products/ProductsSettings/paymentGatewayOptions";
import { useAppSelector } from "~/store/initializeStore";
import TPayIntegrationPanel from "./clients/tpay/TPayIntegrationPanel";
import PaymentIntegration from "./PaymentIntegration";

const PaymentGateways: FunctionComponent = () => {
  const { t } = useTranslation(["settings", "common"]);

  const { data } = useAppSelector((state) => state.productsSettings);
  const [selectedGateway, setGateway] = useState<PaymentGateway>(PaymentGateway.Stripe);

  if (!data) {
    return null;
  }

  const renderActiveIntegration = () => {
    if (selectedGateway === PaymentGateway.Stripe) {
      return (
        <PaymentIntegration
          connected={!!data?.isStripeConnected}
          integrations={data?.paymentGateways?.[PaymentGateway.Stripe] || null}
        />
      );
    }

    if (selectedGateway === PaymentGateway.Tpay) {
      return <TPayIntegrationPanel integrations={data?.paymentGateways?.[PaymentGateway.Tpay] || null} />;
    }

    return null;
  };

  return (
    <div className="mx-auto flex min-w-[450px] max-w-lg flex-col items-center pt-8">
      <Space direction="vertical" size={24}>
        <Row gutter={24} justify="center">
          <Segmented
            size="large"
            options={paymentGatewayOptions.map((gateway) => ({
              value: gateway.value,
              label: (
                <div>
                  {t(gateway.label)}{" "}
                  {data.paymentGateways &&
                  gateway.value in data.paymentGateways &&
                  data.paymentGateways?.[gateway.value]?.length ? (
                    <CheckCircleOutlined style={{ color: "#1bc5bd" }} />
                  ) : null}
                </div>
              ),
            }))}
            value={selectedGateway}
            onChange={(value) => setGateway(value as PaymentGateway)}
          />
        </Row>
      </Space>

      <div className="mt-6">{renderActiveIntegration()}</div>
    </div>
  );
};

export default PaymentGateways;
